(function () {
  if (customElements.get('collection-products-slider')) return;

  class CollectionProductsSlider extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector('.collection-products-slider__slider');
      if (!this.slider) return;

      this.cleanupBreakpoint = window.SliderSettings.onBreakpointChange(() => {
        this.destroySlider();
        this.createSlider();
      });

      if (typeof Flickity !== 'undefined') {
        this.createSlider();
      } else {
        window.addEventListener('load', () => this.createSlider(), { once: true });
      }
    }

    createSlider() {
      if (typeof Flickity === 'undefined') return;
      const opts = window.getFlickityOptions(this);
      this.flkty = new Flickity(this.slider, opts);

      if (typeof window.datoraUpdatePrices === 'function') {
        window.datoraUpdatePrices(this);
      }
    }

    destroySlider() {
      if (this.flkty) {
        this.flkty.destroy();
        this.flkty = null;
      }
    }

    disconnectedCallback() {
      this.cleanupBreakpoint?.();
      this.destroySlider();
    }
  }

  customElements.define('collection-products-slider', CollectionProductsSlider);
})();
